import { format } from "date-fns";

export const KIND_STYLE = {
  Template: "border-purple-500/30 bg-purple-500/10 text-purple-200",
  Fabrication: "border-amber-500/30 bg-amber-500/10 text-amber-200",
  Install: "border-blue-500/30 bg-blue-500/10 text-blue-200",
  Service: "border-red-500/30 bg-red-500/10 text-red-200",
  Material: "border-emerald-500/30 bg-emerald-500/10 text-emerald-200",
  Arrival: "border-orange-500/30 bg-orange-500/10 text-orange-200",
  Viewing: "border-cyan-500/30 bg-cyan-500/10 text-cyan-200",
  Note: "border-zinc-600 bg-zinc-800 text-zinc-300",
};

export const KIND_BAR = {
  Template: "bg-purple-500/60",
  Fabrication: "bg-amber-500/60",
  Install: "bg-blue-500/60",
  Service: "bg-red-500/60",
  Material: "bg-emerald-500/60",
  Arrival: "bg-orange-500/60",
  Viewing: "bg-cyan-500/60",
  Note: "bg-zinc-600",
};

export const STAGES = ["Lead", "Quoted", "Approved", "Template", "Fabrication", "Install", "Complete", "Lost"];

export const iso = (d) => format(d, "yyyy-MM-dd");

export const openPath = (e) =>
  e.entity === "job"
    ? `/projects/${e.id}?tab=field`
    : e.entity === "service"
      ? `/projects/service`
      : e.entity === "po"
        ? `/inventory/purchase-orders/${e.id}`
        : e.entity === "viewing"
          ? `/viewings/${e.id}`
          : `/reservation/${e.id}`;
